import './rateCard.css';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { handleNumberFieldFocus, titleCase } from '../../../common/commonFunction';
import { addRateCard, deleteDocument, fetchBudgetApprovalRole, getRateUnits, provideClarificationRateCard, saveRateCardDraft } from './rateCardAPIs';
import { viewdownloadDocument } from '../resourceCommonAPIs';
import { processMultipleWorkFlow } from '../seeAllWorkList/workListAPIs';
import { STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_ALL, NO_DATA_AVAILABLE, PROCEED, NEXT, FILE_NAME_VALIDATION_ERROR, RESOURCE_ROLES } from '../../../common/constants';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { PROD } from '../../../common/constants';
import { Fab, Alert, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, DialogContent, Dialog, DialogActions, Button, RadioGroup, Radio, Container, Stack, Link, Box, Typography, Grid, FormHelperText, FormControl, FormControlLabel, FormLabel, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { format } from 'date-fns';
import { allowedFileTypes } from '../../../common/constants';
import { VALIDATION, backgroundMaxLength, capitalizeFunction, fileNameValidation, justificationMaxLength, openTextFieldMaxLength } from '../../../common/commonValidations';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import TrashIcon from '../../../images/TrashIcon.png';
import { authKey, DELETE_DRAFT_DOCS, DELETE_RATE_CARD_DOCS, EDIT_WORKFLOW_REQUEST, UPLOAD_DCUMENT } from '../../../common/URLs';

import { loaderService } from "../../../common/custom-loader/loader-service";
import { lastFiveDigitsComparator } from "../../../common/commonFunction";
import { useTranslation } from "react-i18next";
import Badge from 'react-bootstrap/Badge';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import ReactToPrint from "react-to-print";
import DeleteIcon from '@mui/icons-material/Delete';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { ApproveIcon, CloseIcon, EditIcon, PreviewIcon, PrintIcon, ReportIcon, SaveIcon, SubmitIcon } from '../../../common/icons';
import apiClient from '../../../axios';
import dayjs from 'dayjs';

function PreviewRateCard() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [documentsArr, setDocumentsArr] = useState([]);
    const [saveDraftResponse, setSaveDraftResponse] = useState();
    const [characterLimit] = useState(500);
    const [preview, setPreview] = useState(false);
    const [isConfirmProcessing, setIsConfirmProcessing] = useState(false);
    const [isSaveDraftProcessing, setIsSaveDraftProcessing] = useState(false);
    const [isEditApiProcessing, setIsEditApiProcessing] = useState(false);
    const [unitsList, setUnitsList] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);

    const { state } = useLocation();

    const [addedRateCardDetailsArr, setAddedRateCardDetailsArr] = useState(
        state?.addedRateCardDetailsArr || []
    );

    const [requestNumber, setRequestNumber] = useState(
        state?.addedRateCardDetailsArr?.[0]?.requestNumber || null
    );

    const [itemRateUniqueArr, setItemRateUniqueArr] = useState([]);
    const [submissionDetails, setSubmissionDetails] = useState({
        background: state?.selectedRequestNumber ? state?.addedRateCardDetailsArr?.[0]?.background : "",
        finalSummary: state?.selectedRequestNumber ? state?.addedRateCardDetailsArr?.[0]?.finalSummary : "",
        commonComment: ""
    });

    const [errorMessage, setErrorMessage] = useState({
        approvalBudgetError: "",
        backgroundError: "",
        finalSummaryError: "",
        commentError: ""
    });
    
    const [finalSubmissionRateArr, setFinalSubmissionRateArr] = useState();
    const [rateCardResponse, setRateCardResponse] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [radioError, setRadioError] = useState();
    const [approvalArr, setApprovalArr] = useState();
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const width = state?.selectedRequestNumber || (state?.category === "HIT" && state?.itemType === "Transportation Rate") ? "100%" : "75%";

    const [logConfirmModalOpen2, setLogConfirmModalOpen2] = useState(false);
    const handleConfirmLogModalOpen2 = () => setLogConfirmModalOpen2(true);
    const handleConfirmLogModalClose2 = () => setLogConfirmModalOpen2(false);

    const [logConfirmModalOpen3, setLogConfirmModalOpen3] = useState(false);
    const handleConfirmLogModalOpen3 = () => setLogConfirmModalOpen3(true);
    const handleConfirmLogModalClose3 = () => setLogConfirmModalOpen3(false);

    const [editWorkflowConfirmModalOpen, setEditWorkflowConfirmModalOpen] = useState(false);
    const handleConfirmEditWorkflowOpen = () => setEditWorkflowConfirmModalOpen(true);
    const handleConfirmEditWorkflowClose = () => setEditWorkflowConfirmModalOpen(false);

    const [deleteItem, setDeleteItem] = useState();
    const [deleteDraftItem, setDeleteDraftItem] = useState();
    const [deleteDocumentResponse, setDeleteDocumentResponse] = useState();
    const [deleteDraftDocumentResponse, setDeleteDraftDocumentResponse] = useState();
    const [clarificationProcessWrkflow, setClarificationProcessWrkflow] = useState();
    const [deletedDocFromResponse, setDeletedDocFromResponse] = useState();
    const [deletedDraftDocFromResponse, setDeletedDraftDocFromResponse] = useState();
    const [saveDraftClick, setSaveDraftClick] = useState(false);

    const totalRate = state?.addedRateCardDetailsArr?.reduce((sum, item) => Number(sum) + Number(item?.itemRate), 0);
    const [budgetApprovalRole, setBudgetApprovalRole] = useState();
    const [approvalBudget, setApprovalBudget] = useState((state?.currentStatus === "Draft" || state?.selectedRequestNumber) ? state?.addedRateCardDetailsArr?.[0]?.approvalBudget : '');

    const isFieldsDisabled = state?.selectedRequestNumber && state?.currentStatus !== "Draft" && state?.addedRateCardDetailsArr?.some(item1 => item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification"
        &&
        !(
            getLocalStorageItem('role') === RESOURCE_ROLES?.PlantSCMMember &&
            item1?.status !== "COMPLETED"
        )
    ) ? true : false;

    const isEditAllowed =
        state?.selectedRequestNumber &&
        state?.currentStatus !== "Draft" &&
        getLocalStorageItem("role") === RESOURCE_ROLES?.PlantSCMMember &&
        state?.addedRateCardDetailsArr?.some(
            item1 => item1?.status !== "COMPLETED"
        );


    const effectiveFieldsDisabled = isFieldsDisabled || (isEditAllowed && !isEditMode);

    const editWorkflowRequest = async (payloadData) => {
        if (isEditApiProcessing) return;
        setIsEditApiProcessing(true);
        loaderService.showLoader();

        const mappedRateCardDetailsLst = state?.addedRateCardDetailsArr?.map((originalItem) => {
            const matchedUniqueGroup = itemRateUniqueArr.find(
                (unique) => unique?.originalRate === originalItem?.itemRate && unique?.originalUnit === originalItem?.unitPer
            );

            return {
                ...originalItem,
                background: submissionDetails?.background,
                finalSummary: submissionDetails?.finalSummary,
                approvalBudget: Number(approvalBudget) || originalItem?.approvalBudget || 0,

                itemRate: matchedUniqueGroup ? matchedUniqueGroup.itemRate : originalItem?.itemRate,
                unitPer: matchedUniqueGroup ? matchedUniqueGroup.unitPer : originalItem?.unitPer,
                justification: matchedUniqueGroup ? matchedUniqueGroup.justification : originalItem?.justification,
                deletionComment: originalItem?.deletionComment || "",

                documents: documentsArr?.map(doc => ({
                    id: doc?.id,
                    containerName: doc?.containerName || "resourcefiles",
                    documentName: doc?.documentName,
                    documentGuid: doc?.documentGuid,
                    isActive: doc?.isActive || "Y",
                    createdBy: doc?.createdBy || getLocalStorageItem("userName"),
                    createdOn: doc?.createdOn || dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    updatedBy: getLocalStorageItem("userName"),
                    updatedOn: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    mainTableId: originalItem?.id || "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                })),

                workflowRqstDtls: {
                    ...originalItem?.workflowRqstDtls,
                    requestNumber: originalItem?.requestNumber || originalItem?.workflowRqstDtls?.requestNumber,
                    applicationNumber: originalItem?.applicationNumber || originalItem?.workflowRqstDtls?.applicationNumber,
                    operation: originalItem?.workflowRqstDtls?.operation || "UPDATE",
                    workflowCommentHistory: originalItem?.workflowRqstDtls?.workflowCommentHistory?.map(history => ({
                        ...history,
                        updatedOn: history?.updatedOn || new Date().toISOString()
                    })) || []
                }
            };
        }) || [];

        const comprehensivePayload = {
            rateCardDtlsLst: mappedRateCardDetailsLst,
            errorMessage: null,
            ...payloadData
        };

        try {
            const response = await apiClient.post(EDIT_WORKFLOW_REQUEST, comprehensivePayload, {
                headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') }
            });
            if (response.data) {
                toast.success("Request Edited Successfully.");
                setIsEditMode(false); 
                // navigate(-1);
            }
        } catch (error) {
            console.error("Error modifying active workflow parameters: ", error);
            toast.error("Failed to execute workflow structural configuration update.");
        } finally {
            loaderService.hideLoader();
            setIsEditApiProcessing(false);
        }
    };

    useEffect(() => {
        getRateUnits(setUnitsList);
    }, [getLocalStorageItem('role')]);

    const handleChange = (e, uniqueItem, dynamicFieldType = null) => {

        if (uniqueItem && dynamicFieldType) {
            const targetValue = e.target.value;

            const updatedUniqueGrid = itemRateUniqueArr?.map(item => {
                if (item?.id === uniqueItem?.id) {
                    return {
                        ...item,
                        ...(dynamicFieldType === "rate" && { itemRate: targetValue }),
                        ...(dynamicFieldType === "unitPer" && { unitPer: targetValue })
                    };
                }
                return item;
            });

            setItemRateUniqueArr(updatedUniqueGrid);
            return;
        }

        e.preventDefault();
        if (uniqueItem) {
            const tempArr = (itemRateUniqueArr?.map(item => {
                if (item?.id === uniqueItem?.id) {
                    e.target.name === "remarks" ? item.remarks = VALIDATION.noSpecialCharacterValidation(e.target.value) : item[e.target.name] = VALIDATION.noSpecialCharacterValidation(e.target.value)
                    e.target.name === "remarks" ? item.remarksError = "" : item.justificationError = ""
                }
                return item;
            }
            ));
            setItemRateUniqueArr(tempArr);
        }
        else {
            setSubmissionDetails({ ...submissionDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) });
        }
        if (e.target.name === "background") {
            setErrorMessage({ ...errorMessage, backgroundError: "" });
        }
        if (e.target.name === "finalSummary") {
            setErrorMessage({ ...errorMessage, finalSummaryError: "" });
        }
    };

    const radioChange = (e, applicationNumber) => {
        const tempArr = (approvalArr?.map(item => {
            if (item?.applicationNumber === applicationNumber) {
                item.action = e.target.value;
            }
            return item;
        }
        ));
        setApprovalArr(tempArr);
    };

    const onGoBack = (e) => {
        e.preventDefault();
        if (state?.selectedRequestNumber && state?.currentStatus !== "Draft") {
            navigate(-1);
        }
        else {
            navigate((-1), { state: { rateCardDetailsArr: state?.rateCardDetailsArr, addedRateCardDetailsArr: state?.addedRateCardDetailsArr, finalRateCardDetailsArr: state?.finalRateCardDetailsArr, urnsList: state?.urnsList, category: state?.category, itemType: state?.itemType, unitPer: state?.unitPer, itemRate: state?.itemRate, validFrom: state?.validFrom, validTo: state?.validTo, validFromProceed: state?.validFromProceed, validToProceed: state?.validToProceed, state: state?.state, district: state?.district, revenueCircle: state?.revenueCircle, routeType: state?.routeType } });
        }
    };

    const onAllClick = (e, actionType) => {
        const tempApprovalArr = (approvalArr?.map(item => {
            item.action = actionType;
            return item;
        }
        ));
        setApprovalArr(tempApprovalArr);
    };

    const PreviewClick = () => {
        if (state?.currentStatus !== "Draft" && !approvalBudget) {
            setErrorMessage({ ...errorMessage, approvalBudgetError: "Please enter approval budget" });
        }
        else {
            fetchBudgetApprovalRole(setBudgetApprovalRole, state?.currentStatus === "Draft" && state?.addedRateCardDetailsArr?.[0]?.approvalBudget ? state?.addedRateCardDetailsArr?.[0]?.approvalBudget : approvalBudget);
            setErrorMessage({ ...errorMessage, approvalBudgetError: "" });
        }
    };

    useEffect(() => {
        if (!budgetApprovalRole) return;

        if (budgetApprovalRole?.budgetApproverFound === false) {
            toast.error(
                "Budget approver role is not found! Please add budget approver role based on budget range"
            );
            return;
        }

        if (saveDraftClick) {
            const tempArray = addedRateCardDetailsArr.map((item) => {
                const justification = itemRateUniqueArr.find(
                    (uniqueItem) => uniqueItem.originalRate === item.itemRate && uniqueItem?.originalUnit === item?.unitPer
                )?.justification;

                return {
                    ...item,
                    background: submissionDetails?.background,
                    finalSummary: submissionDetails?.finalSummary,
                    draftDocs: documentsArr,
                    justification,
                    approvalBudget,
                    finalBudgetApprover: budgetApprovalRole?.budgetApproverRole,
                    createdName: getLocalStorageItem("userName"),
                    createdRole: getLocalStorageItem("role"),
                    requestNumber: requestNumber ?? item.requestNumber ?? null,
                    name: item?.name ?? item?.stakeholderName ?? null,
                    stakeholderName: item?.name ?? item?.stakeholderName ?? null,
                };
            });

            saveRateCardDraft(tempArray, setSaveDraftResponse, setSaveDraftClick);
        } else {
            onPreview();
        }
    }, [budgetApprovalRole]);

    const onPreview = () => {
        if (!submissionDetails?.background) {
            setErrorMessage({ ...errorMessage, backgroundError: "Please enter the background" });
        }
        else if (!submissionDetails?.finalSummary) {
            setErrorMessage({ ...errorMessage, finalSummaryError: "Please enter the final summary" });
        }
        else if (itemRateUniqueArr.some(item => !item?.justification)) {
            const tempApprovalArr = (itemRateUniqueArr?.map(item => {
                if (!item?.justification) {
                    item.justificationError = "Please enter the justification";
                }
                return item;
            }
            ));
            setItemRateUniqueArr(tempApprovalArr);
        }
        else if (documentsArr?.length == 0) {
            setFileuploadError("Please upload a document");
        }
        else {
            setPreview(true);
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (state?.selectedRequestNumber && state?.currentStatus !== "Draft") {
            if (state?.addedRateCardDetailsArr?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification")) {
                if (!submissionDetails?.background) {
                    setErrorMessage({ ...errorMessage, backgroundError: "Please enter the background" });
                }
                else if (!submissionDetails?.finalSummary) {
                    setErrorMessage({ ...errorMessage, finalSummaryError: "Please enter the final summary" });
                }
            }
            if (state?.currentStatus !== "Draft" && approvalArr.some(item => item.action === null)) {
                toast.error("Please act on all applications");
            }
            else if (state?.currentStatus !== "Draft" && itemRateUniqueArr?.some(item => !item?.remarks)) {
                const tempApprovalArr = (itemRateUniqueArr?.map(item => {
                    if (!item?.remarks) {
                        item.remarksError = "Please enter the comment";
                    }
                    else if (!item?.justification) {
                        item.justificationError = "Please enter the justification";
                    }
                    return item;
                }
                ));
                setItemRateUniqueArr(tempApprovalArr);
            }
            else if (documentsArr?.length === 0) {
                setFileuploadError("Please upload a document");
            }
            else {
                handleConfirmLogModalOpen();
            }
        }
        else {
            if (!submissionDetails?.background) {
                setErrorMessage({ ...errorMessage, backgroundError: "Please enter the background" });
            }
            else if (!submissionDetails?.finalSummary) {
                setErrorMessage({ ...errorMessage, finalSummaryError: "Please enter the final summary" });
            }
            else if (itemRateUniqueArr.some(item => !item?.justification)) {
                const tempApprovalArr = (itemRateUniqueArr?.map(item => {
                    if (!item?.justification) {
                        item.justificationError = "Please enter the justification";
                    }
                    return item;
                }
                ));
                setApprovalArr(tempApprovalArr);
            }
            else if (documentsArr?.length === 0) {
                setFileuploadError("Please upload a document");
            }
            else {
                handleConfirmLogModalOpen();
            }

        }
    };

    function onConfirmCallBack() {
        if (isConfirmProcessing) return;
        setIsConfirmProcessing(true);

        try {
            handleConfirmLogModalClose();

            if (
                state?.selectedRequestNumber &&
                state?.currentStatus !== "Draft" &&
                state?.addedRateCardDetailsArr?.every(
                    (item1) =>
                        item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification"
                )
            ) {
                const tempArr = state?.addedRateCardDetailsArr?.map((item) => {
                    item.remarks = itemRateUniqueArr.find(
                        (uniqueItem) => uniqueItem?.originalRate === item?.itemRate && uniqueItem?.originalUnit === item?.unitPer
                    )?.remarks;
                    return item;
                });

                const tempArrApproval = approvalArr?.map((item) => {
                    item.remarks =
                        tempArr.find(
                            (uniqueItem) =>
                                uniqueItem?.applicationNumber === item?.applicationNumber
                        )?.remarks || submissionDetails?.commonComment;
                    return item;
                });

                setFinalSubmissionRateArr(tempArrApproval);
            } else if (
                state?.selectedRequestNumber &&
                state?.currentStatus !== "Draft" &&
                state?.addedRateCardDetailsArr?.every(
                    (item1) =>
                        item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification"
                )
            ) {
                const tempArr = state?.addedRateCardDetailsArr?.map((item) => {
                    item.remarks = itemRateUniqueArr.find(
                        (uniqueItem) => uniqueItem?.originalRate === item?.itemRate && uniqueItem?.originalUnit === item?.unitPer
                    )?.remarks;
                    return item;
                });

                const tempArrApproval = approvalArr?.map((item) => {
                    item.remarks =
                        tempArr.find(
                            (uniqueItem) =>
                                uniqueItem?.applicationNumber === item?.applicationNumber
                        )?.remarks || submissionDetails?.commonComment;
                    return item;
                });

                const tempArray = state?.addedRateCardDetailsArr?.map((item) => {
                    item.background = submissionDetails?.background;
                    item.finalSummary = submissionDetails?.finalSummary;
                    item.documents = documentsArr;
                    item.justification = itemRateUniqueArr.find(
                        (uniqueItem) => uniqueItem.originalRate === item.itemRate && uniqueItem?.originalUnit === item?.unitPer
                    )?.justification;
                    return item;
                });

                setFinalSubmissionRateArr(tempArray);
                setClarificationProcessWrkflow(tempArrApproval);
            } else {
                const tempArr = state?.addedRateCardDetailsArr?.map((item) => {
                    return {
                        ...item,
                        background: submissionDetails?.background,
                        finalSummary: submissionDetails?.finalSummary,
                        documents: documentsArr,
                        justification: itemRateUniqueArr.find(
                            (uniqueItem) => uniqueItem.originalRate === item.itemRate && uniqueItem?.originalUnit === item?.unitPer
                        )?.justification,
                        requestNumber: requestNumber ?? item.requestNumber ?? null,
                    };
                });
                setFinalSubmissionRateArr(tempArr);
            }
        } finally {
            setIsConfirmProcessing(false);
        }
    }

    function onCancelBack() {
        handleConfirmLogModalClose();
    }

    const onInsertComment = (e) => {
        const tempArrApproval = (itemRateUniqueArr?.map(item => {
            item.remarks = submissionDetails?.commonComment;
            item.remarksError = "";
            return item;
        }
        ));
        setItemRateUniqueArr(tempArrApproval);
    };

    useEffect(() => {
        if (selectedFile) {
            getDocumentUploadDetails();
        }
    }, [selectedFile]);

    useEffect(() => {
        let tempArr = state?.addedRateCardDetailsArr?.[0]?.documents || [];
        if (deletedDocFromResponse) {
            tempArr = tempArr.filter(item => item.documentGuid !== deletedDocFromResponse.documentGuid);
        }
        setDocumentsArr(tempArr);
    }, [state?.addedRateCardDetailsArr, deletedDocFromResponse]);

    useEffect(() => {
        setDocumentsArr(state?.addedRateCardDetailsArr?.[0]?.documents || []);
    }, [state?.addedRateCardDetailsArr]);

    useEffect(() => {
        if (documentUploadDetails) {
            let tempARR = documentsArr ? [...documentsArr] : [];
            documentUploadDetails && tempARR.push(documentUploadDetails);
            setDocumentsArr(tempARR);
        }
    }, [documentUploadDetails]);

    const uploadDocument = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setFileuploadError('The file should be less than 5MB');
            setSelectedFile();
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            setFileuploadError("Double extension file detected");
            setSelectedFile();
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setFileuploadError(FILE_NAME_VALIDATION_ERROR);
            setSelectedFile();
        }
        else {
            setSelectedFile(e.target.files[0]);
            setFileuploadError('');
        }
    };

    function getDocumentUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "resourcefiles");
        apiClient
            .post(
                UPLOAD_DCUMENT,
                formData,
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                let res = {
                    documentGuid: response.data.blobResponse.blobFileName,
                    documentName: response.data.blobResponse.fileName,
                    containerName: "resourcefiles",
                };
                setDocumentUploadDetails(res);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    useEffect(() => {
        if (state?.addedRateCardDetailsArr) {
            const uniqueItemRates = [];
            state?.addedRateCardDetailsArr?.map((item, idx) => {
                var findItem = uniqueItemRates.find((uniqueItem) => uniqueItem?.originalRate === item?.itemRate && uniqueItem.originalUnit === item?.unitPer);
                if (!findItem) {
                    uniqueItemRates.push({
                        id: `group-${idx}`,
                        originalRate: item?.itemRate,
                        originalUnit: item?.unitPer,
                        itemRate: item?.itemRate,
                        justification: item?.justification,
                        unitPer: item?.unitPer,
                        remarks: '',
                        justificationError: '',
                        remarksError: ''
                    });
                }
            });
            setItemRateUniqueArr(uniqueItemRates);
            const tempApprovalArr = [];
            state?.addedRateCardDetailsArr?.map((item) => {
                tempApprovalArr.push({ remarks: '', action: null, applicationNumber: item?.applicationNumber });
            });
            setApprovalArr(tempApprovalArr);
        }
    }, [state?.addedRateCardDetailsArr]);

    useEffect(() => {
        if (finalSubmissionRateArr && finalSubmissionRateArr?.length !== 0) {
            if (state?.selectedRequestNumber && state?.currentStatus !== "Draft") {
                if (state?.addedRateCardDetailsArr?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification")) {
                    provideClarificationRateCard(setRateCardResponse, finalSubmissionRateArr, state?.addedRateCardDetailsArr?.[0]);
                    processMultipleWorkFlow(clarificationProcessWrkflow, setRateCardResponse);
                }
                else processMultipleWorkFlow(finalSubmissionRateArr, setRateCardResponse);
            }
            else addRateCard(setRateCardResponse, finalSubmissionRateArr, budgetApprovalRole);
        }
    }, [finalSubmissionRateArr]);

    useEffect(() => {
        if (rateCardResponse) {
            if (rateCardResponse?.status === "SUCCESS") {
                toast.success(rateCardResponse?.description);
                navigate(-1);
            }
            else {
                toast.error(rateCardResponse?.description);
            }
        }
    }, [rateCardResponse]);

    const deleteFromArr = (documentGuid) => {
        const updatedDocuments = documentsArr.filter(doc => doc.documentGuid !== documentGuid);
        setDocumentsArr(updatedDocuments);
    };

    const handleDelete = (doc) => {
        if (doc.id) {
            setDeleteItem(doc);
            handleConfirmLogModalOpen2();
        } else {
            deleteFromArr(doc.documentGuid);
        }
    };

    function onConfirmCallBack2() {
        if (isConfirmProcessing) return;
        handleConfirmLogModalClose2();
        deleteDocument(deleteItem);
    }

    function onCancelBack2() {
        handleConfirmLogModalClose2();
    }

    const deleteDocument = (item) => {
        loaderService.showLoader();
        apiClient
            .post(DELETE_RATE_CARD_DOCS,
                [item],
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setDeleteDocumentResponse(response.data[0]?.respStts);
                setDeletedDocFromResponse(response.data[0]?.docsApplication);
                const deletedDoc = response?.data[0]?.docsApplication;
                const updatedDocuments = documentsArr?.filter(item => item?.documentGuid !== deletedDoc?.documentGuid);
                setDocumentsArr(updatedDocuments);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    };

    useEffect(() => {
        if (deleteDocumentResponse) {
            if (deleteDocumentResponse.status === "SUCCESS") {
                toast.success(deleteDocumentResponse?.description);
            } else toast.error(deleteDocumentResponse?.description ? deleteDocumentResponse?.description : "Error");
        }
    }, [deleteDocumentResponse]);

    const handleDraftDocDelete = (doc) => {
        if (doc.id) {
            setDeleteDraftItem({ ...doc, "isActive": "N" });
            handleConfirmLogModalOpen3();
        } else {
            deleteFromArr(doc.documentGuid);
        }
    };

    function onConfirmDraftDocDelete() {
        if (isConfirmProcessing) return;
        handleConfirmLogModalClose3();
        deleteDraftDocument(deleteDraftItem);
    }

    function onCancelDraftDocDelete() {
        handleConfirmLogModalClose3();
    }

    const deleteDraftDocument = (item) => {
        loaderService.showLoader();
        apiClient
            .post(
                DELETE_DRAFT_DOCS,
                [item],
                { headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') } },
                null
            )
            .then((response) => {
                setDeleteDraftDocumentResponse(response.data[0]?.respStts);
                const deletedDoc = response?.data[0]?.rateCardDocsDraft;
                setDeletedDraftDocFromResponse(deletedDoc);

                setDocumentsArr(prev =>
                    prev?.filter(d => d?.documentGuid !== deletedDoc?.documentGuid)
                );

                loaderService.hideLoader();
            })
            .catch((error) => {
                console.log(error);
                loaderService.hideLoader();
            });
    };

    useEffect(() => {
        if (deleteDraftDocumentResponse) {
            if (deleteDraftDocumentResponse.status === "SUCCESS") {
                toast.success(deleteDraftDocumentResponse?.description);
            } else toast.error(deleteDraftDocumentResponse?.description ? deleteDraftDocumentResponse?.description : "Error");
        }
    }, [deleteDraftDocumentResponse]);

    const commentColumns = [
        { field: 'previousStepUser', headerName: "User", width: 270 },
        {
            field: 'previousStepComments', headerName: "Comment", width: 630,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
    ];

    const viewURNDetails = (urn) => {
        navigate("./viewPageWraper", { state: { urn: urn, goBack: true } });
    };

    const onSaveDraft = async () => {
        if (isSaveDraftProcessing) return;
        setIsSaveDraftProcessing(true);

        try {
            setSaveDraftClick(true);

            if (approvalBudget) {
                await fetchBudgetApprovalRole(setBudgetApprovalRole, approvalBudget);
                return;
            }

            const tempArray = addedRateCardDetailsArr.map((item) => {
                const justification = itemRateUniqueArr.find(
                    (uniqueItem) => uniqueItem.originalRate === item.itemRate && uniqueItem?.originalUnit === item?.unitPer
                )?.justification;

                return {
                    ...item,
                    background: submissionDetails?.background,
                    finalSummary: submissionDetails?.finalSummary,
                    draftDocs: documentsArr,
                    justification,
                    approvalBudget,
                    finalBudgetApprover: "",
                    createdName: getLocalStorageItem("userName"),
                    createdRole: getLocalStorageItem("role"),
                    requestNumber: requestNumber ?? item.requestNumber ?? null,
                    name: item?.name ?? item?.stakeholderName ?? null,
                    stakeholderName: item?.name ?? item?.stakeholderName ?? null,
                };
            });

            await saveRateCardDraft(
                tempArray,
                setSaveDraftResponse,
                setSaveDraftClick
            );
        } catch (error) {
            console.error("SAVE DRAFT failed:", error);
        } finally {
            setIsSaveDraftProcessing(false);
        }
    };

    useEffect(() => {
        if (!saveDraftResponse) return;

        const { abrplRespStts, rateDraftList } = saveDraftResponse;

        if (abrplRespStts?.status === "SUCCESS") {
            toast.success(abrplRespStts?.description);

            const reqNo = rateDraftList?.[0]?.requestNumber || null;

            if (reqNo) {
                setRequestNumber(reqNo);
            }

            if (Array.isArray(rateDraftList) && rateDraftList.length) {
                setAddedRateCardDetailsArr(rateDraftList);
            }
        } else {
            toast.error(abrplRespStts?.description);
        }
    }, [saveDraftResponse]);

    const columns = [
        {
            field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 150,
            sortComparator: (a, b) => lastFiveDigitsComparator(a, b), renderCell: (params) => { return (<Link to={params} onClick={() => { viewURNDetails(params?.row?.urnNumber); }}>{params.value}</Link>); }
        },
        {
            field: 'name', headerName: STAKEHOLDER_NAME, width: 190,
            valueGetter: (params) => params.value ? params?.value : params?.row?.stakeholderName
        },
        {
            field: 'registrationNo', headerName: REGISTRATION_NO, width: 150, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true,
            renderCell: (params) => {
                return params?.row?.registrationNo ? params?.row?.registrationNo : params?.row?.vehicleRegNo;
            }
        },
        { field: 'vehicleType', headerName: VEHICLE_TYPE, width: 150, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true },
        {
            field: 'vehicleCapacity', headerName: VEHICLE_CAPACITY, width: 150, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true,
            renderCell: (params) => {
                return params?.row?.vehicleCapacity ? params?.row?.vehicleCapacity : params?.row?.vehicleCap;
            }
        },
        { field: 'vehicleMake', headerName: VEHICLE_MAKE, width: 150, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true },
        { field: 'vehicleModel', headerName: VEHICLE_MODEL, width: 150, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true },
        {
            field: 'state', headerName: STATE, width: 150, hide: state?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                );
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: state?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                );
            }
        },
        {
            field: 'route', headerName: ROUTE, width: 190, hide: state?.category !== "Transporter" || state?.itemType !== "Transportation Rate" && true,
            valueGetter: (params) => {
                if (params?.row?.route) {
                    return params?.row?.route;
                } else return params?.row?.fromName + " to " + params?.row?.toName;
            },
            renderCell: (params) => {
                return (
                    params?.row?.route ? params?.row?.route : params?.row?.fromName + " to " + params?.row?.toName
                );
            }
        },
        { field: "toName", headerName: "Destination", width: 200, hide: state?.category !== "HIT" || state?.itemType !== "Transportation Rate" && true },
        { field: 'landName', headerName: LAND_NAME, width: 150, hide: state?.category !== "Grower" && state?.itemType !== "Bamboo Rate" },
        {
            field: 'validFrom', headerName: 'Valid From', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {format(new Date(params?.row?.validFrom), 'dd/MM/yyyy')}
                    </>
                );
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {format(new Date(params?.row?.validTo), 'dd/MM/yyyy')}
                    </>
                );
            }
        },
        {
            field: 'actions', headerName: 'Actions', width: 450, hide: !(state?.selectedRequestNumber && (state?.type !== "sent" && state?.type !== "actionTaken")),
            renderCell: (params) => {
                return (
                    <>
                        {params?.row?.workflowRqstDtls?.previousStepAction === "Seek_Clarification" ?
                            <>
                                <FormControl>
                                    <RadioGroup row name="radio-buttons-group1">
                                        <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Rate_Clarification" checked={approvalArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Rate_Clarification"} onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Provide Clarification" />
                                    </RadioGroup>
                                </FormControl>
                            </> :
                            <>
                                <FormControl>
                                    <RadioGroup row aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group2">
                                        <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Approved" checked={approvalArr?.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Approved"} onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Approve" />
                                        <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Rejected" checked={approvalArr?.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Rejected"} onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Reject" />
                                        <FormControlLabel name={"action" + params?.row?.applicationNumber} value="Seek_Clarification" checked={approvalArr.find((approvalItem) => approvalItem?.applicationNumber === params?.row?.applicationNumber)?.action === "Seek_Clarification"} onChange={(e) => radioChange(e, params?.row?.applicationNumber)} control={<Radio size="small" />} label="Seek for clarification" />
                                    </RadioGroup>
                                </FormControl>
                            </>
                        }
                    </>
                );
            }
        }
    ];

    const componentRef = useRef();

    const ComponentToPrint = React.forwardRef((props, ref) => {
        const usersArr = state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.workflowCommentHistory?.map(emailItem => emailItem.previousStepUser);
        return (
            <div ref={ref} >
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Typography variant="h5" gutterBottom>
                        {state?.addedRateCardDetailsArr?.[0]?.itemType} {state?.currentStatus === "Draft" ? "Draft" : "Approval"} for {state?.addedRateCardDetailsArr?.[0]?.category}s
                    </Typography>
                </Stack>
                {state?.selectedRequestNumber &&
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
                        <Typography variant="h6" gutterBottom>
                            Assignment-Operation:  {state?.currentStatus === "Draft" ? "Create" : state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation}, Request No/Approval Note No: {state?.addedRateCardDetailsArr?.[0]?.requestNumber}, Date: {format(new Date(state?.addedRateCardDetailsArr?.[0]?.createdOn), 'dd/MM/yyyy')}
                        </Typography>
                    </Stack>}
                {state?.addedRateCardDetailsArr?.[0]?.category === "Grower" && state?.addedRateCardDetailsArr?.[0]?.itemType === "Bamboo Rate" &&
                    <><Grid container spacing={1}>
                        <Grid item xs={3} mt={1} direction="row">
                            <Stack direction="row">
                                <Typography variant="subtitle2" gutterBottom>{STATE}:</Typography>
                                <Typography variant="body2" gutterBottom>
                                    {state?.addedRateCardDetailsArr?.[0]?.state && titleCase(state?.addedRateCardDetailsArr?.[0]?.state)}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={3} mt={1}>
                            <Typography variant="subtitle2" gutterBottom>{DISTRICT}:</Typography>
                            <Typography variant="body2" gutterBottom>
                                {state?.addedRateCardDetailsArr?.[0]?.district && titleCase(state?.addedRateCardDetailsArr?.[0]?.district)}
                            </Typography>
                        </Grid>
                        {state?.addedRateCardDetailsArr?.[0]?.revenurCircle && <Grid item xs={3} mt={1}>
                            <Typography variant="subtitle2" gutterBottom>{REVENUE_CIRCLE}:</Typography>
                            <Typography variant="body2" gutterBottom>
                                {state?.addedRateCardDetailsArr?.[0]?.revenurCircle && titleCase(state?.addedRateCardDetailsArr?.[0]?.revenurCircle)}
                            </Typography>
                        </Grid>}
                    </Grid></>
                }
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={8} mt={2}>
                        <Typography variant="subtitle2" gutterBottom>Background:</Typography>
                        <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                            {submissionDetails?.background}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={8} mt={1}>
                        <Typography variant="subtitle2" gutterBottom>Approval Budget(in INR):</Typography>
                        <Typography variant='body2' gutterBottom>
                            {state?.addedRateCardDetailsArr?.[0]?.approvalBudget ? state?.addedRateCardDetailsArr?.[0]?.approvalBudget : approvalBudget}
                        </Typography>
                    </Grid>
                </Grid>
                {itemRateUniqueArr !== 0 && itemRateUniqueArr?.sort((a, b) => a.itemRate > b.itemRate ? 1 : -1)?.map((uniqueItem, index) => (
                    <><Grid container spacing={1} mt={2}>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" gutterBottom>Rate {index + 1}(in INR):</Typography>
                            <Typography variant="body2" gutterBottom>{uniqueItem?.itemRate}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" gutterBottom>Unit:</Typography>
                            <Typography variant="body2" gutterBottom>{uniqueItem?.unitPer}</Typography>
                        </Grid>
                        <Grid item xs={12} lg={12} sx={{ mt: 1 }}>
                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{STAKEHOLDER_URN}</TableCell>
                                            <TableCell>{STAKEHOLDER_NAME}</TableCell>
                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{REGISTRATION_NO}</TableCell>}
                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_TYPE}</TableCell>}
                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_CAPACITY}</TableCell>}
                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_MAKE}</TableCell>}
                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_MODEL}</TableCell>}
                                            {state?.category == "LLE" && <TableCell>{STATE}</TableCell>}
                                            {state?.category == "LLE" && <TableCell>{DISTRICT}</TableCell>}
                                            {state?.category === "Transporter" && <TableCell>{ROUTE}</TableCell>}
                                            {state?.category === "HIT" && state?.itemType === "Transportation Rate" && <TableCell>Destination</TableCell>}
                                            {state?.category == "Grower" && <TableCell>{LAND_NAME}</TableCell>}
                                            {(state?.category == "Grower" && state?.itemType == "Bamboo Rate") && <TableCell>{REVENUE_CIRCLE}</TableCell>}
                                            <TableCell>Valid From</TableCell>
                                            <TableCell>Valid To</TableCell>
                                            {usersArr?.map(userItem => (
                                                <TableCell>Action Taken by {userItem}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer)?.map((row) => (
                                            <TableRow>
                                                <TableCell>{row?.urnNumber}</TableCell>
                                                <TableCell>{row?.name ? row?.name : row?.stakeholderName}</TableCell>
                                                {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.registrationNo ? row?.registrationNo : row?.vehicleRegNo}</TableCell>}
                                                {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleType}</TableCell>}
                                                {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleCapacity ? row?.vehicleCapacity : row?.vehicleCap}</TableCell>}
                                                {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleMake}</TableCell>}
                                                {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleModel}</TableCell>}
                                                {state?.category == "LLE" && <TableCell>{row?.state}</TableCell>}
                                                {state?.category == "LLE" && <TableCell>{row?.district}</TableCell>}
                                                {state?.category === "Transporter" && <TableCell>{row?.route ? row?.route : row?.fromName + " to " + row?.toName}</TableCell>}
                                                {state?.category === "HIT" && state?.itemType === "Transportation Rate" && <TableCell>{row?.toName}</TableCell>}
                                                {state?.category == "Grower" && <TableCell>{row?.landName}</TableCell>}
                                                {(state?.category == "Grower" && state?.itemType == "Bamboo Rate") && <TableCell>{row?.revenueCircle}</TableCell>}
                                                <TableCell>{format(new Date(row?.validFrom), 'dd/MM/yyyy')}</TableCell>
                                                <TableCell>{format(new Date(row?.validTo), 'dd/MM/yyyy')}</TableCell>
                                                {usersArr?.map(userItem => (
                                                    <TableCell>{row?.workflowRqstDtls?.workflowCommentHistory?.find(item => item?.previousStepUser == userItem)?.previousStepAction} on {row?.workflowRqstDtls?.workflowCommentHistory?.find(item => item?.previousStepUser == userItem)?.updatedOn}</TableCell>
                                                ))}</TableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12} lg={6} mt={1}>
                            <Typography variant="subtitle2" gutterBottom>Justification:</Typography>
                            <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                                {uniqueItem?.justification}
                            </Typography>
                        </Grid>

                        {state?.selectedRequestNumber && state?.currentStatus !== "Draft" && (state?.type !== "sent" && state?.type !== "actionTaken") && <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                            <Typography variant="subtitle2" gutterBottom>Approval/Rejection/Clarification Comment:</Typography>
                            <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                                {uniqueItem?.remarks}
                            </Typography></Grid>}
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            {state?.selectedRequestNumber && state?.currentStatus !== "Draft" &&
                                <><Typography variant="subtitle1">{t('reg.commentHistory')}</Typography>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>User</TableCell>
                                                    <TableCell>Comment</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer)[0]?.workflowRqstDtls?.workflowCommentHistory ? state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer)[0].workflowRqstDtls?.workflowCommentHistory?.map((commentItem) => ({ ...commentItem, id: uuidv4() })) : []).map((row) => (
                                                    <TableRow>
                                                        <TableCell>{row?.previousStepUser}</TableCell>
                                                        <TableCell>{row?.previousStepComments}</TableCell>
                                                    </TableRow>
                                                ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </>}
                        </Grid>
                    </Grid>
                    </>
                ))}
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={8} mt={3}>
                        <Typography variant="subtitle2" gutterBottom>Final summary submission:</Typography>
                        <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>
                            {submissionDetails?.finalSummary}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {(state?.selectedRequestNumber ? state?.addedRateCardDetailsArr?.[0]?.documents?.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id))?.map((mapItem) => ({ blobFileName: mapItem.documentGuid, fileName: mapItem.documentName })) : documentsArr)?.map((item, index) => {
                                return (
                                    <div className="Rescview-file-link-common" style={{ display: "flex", flexDirection: "row", marginRight: "2vh" }}>
                                        <Typography>{item?.fileName}</Typography>
                                        {!effectiveFieldsDisabled && <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={() => state?.currentStatus === "Draft" ? handleDraftDocDelete(item) : handleDelete(item)} />}
                                    </div>
                                );
                            })}
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    });

    const getRowHeight = (params) => {
        const row = params?.model;
        if (row?.previousStepComments?.length > 400) return 170;
        else if (row?.previousStepComments?.length > 300) return 150;
        else if (row?.previousStepComments?.length > 200) return 120;
        else if (row?.previousStepComments?.length > 100) return 80;
        else return 50;
    };

    const handleApprovalBudget = (e) => {
        setApprovalBudget(e.target.value);
        setErrorMessage({ ...errorMessage, approvalBudgetError: "" });
    };

    function onConfirmEditWorkflow() {
        handleConfirmEditWorkflowClose();
        editWorkflowRequest({});
    }

    return (
        <>
            {preview ?
                <Container maxWidth="xxl" >
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        <Fab onClick={() => { setPreview(false); }} size="small" aria-label="back" title='Back'>
                            <KeyboardArrowLeftRounded />
                        </Fab>
                        <Typography variant="h5" gutterBottom>
                            {state?.addedRateCardDetailsArr?.[0]?.itemType} {state?.currentStatus === "Draft" ? "Draft" : "Approval"} for {state?.addedRateCardDetailsArr?.[0]?.category}s
                        </Typography>
                    </Stack>
                    {state?.selectedRequestNumber &&
                        <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
                            <Typography variant="h6" gutterBottom>
                                Assignment-Operation: {state?.currentStatus === "Draft" ? "Create" : state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation}, Request No/Approval Note No: {state?.addedRateCardDetailsArr?.[0]?.requestNumber}, Date: {format(new Date(state?.addedRateCardDetailsArr?.[0]?.createdOn), 'dd/MM/yyyy')}
                            </Typography>
                        </Stack>}
                    <Card>
                        <CardContent >
                            {state?.addedRateCardDetailsArr?.[0]?.category === "Grower" && state?.addedRateCardDetailsArr?.[0]?.itemType === "Bamboo Rate" &&
                                <><Grid container spacing={1}>
                                    <Grid item xs={12} lg={3} mt={1} direction="row">
                                        <Typography variant="subtitle2" gutterBottom>{STATE}:</Typography>
                                        <Typography variant="body2" gutterBottom>{state?.addedRateCardDetailsArr?.[0]?.state && titleCase(state?.addedRateCardDetailsArr?.[0]?.state)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={3} mt={1}>
                                        <Typography variant="subtitle2" gutterBottom>{DISTRICT}:</Typography>
                                        <Typography variant="body2" gutterBottom>{state?.addedRateCardDetailsArr?.[0]?.district && titleCase(state?.addedRateCardDetailsArr?.[0]?.district)}</Typography>
                                    </Grid>
                                    {state?.addedRateCardDetailsArr?.[0]?.revenurCircle && <Grid item xs={12} lg={3} mt={1}>
                                        <Typography variant="subtitle2" gutterBottom>{REVENUE_CIRCLE}:</Typography>
                                        <Typography variant="body2" gutterBottom>{state?.addedRateCardDetailsArr?.[0]?.revenurCircle && titleCase(state?.addedRateCardDetailsArr?.[0]?.revenurCircle)}</Typography>
                                    </Grid>}
                                </Grid></>
                            }
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={8} mt={2} >
                                    <Typography variant="subtitle2" gutterBottom>Background:</Typography>
                                    <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>{submissionDetails?.background}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={8} mt={1}>
                                <Typography variant="subtitle2" gutterBottom>Approval Budget (in INR):</Typography>
                                <Typography variant='body2' gutterBottom>
                                    {state?.addedRateCardDetailsArr?.[0]?.approvalBudget ? state?.addedRateCardDetailsArr?.[0]?.approvalBudget : approvalBudget}
                                </Typography>
                            </Grid>
                            {itemRateUniqueArr !== 0 && itemRateUniqueArr?.sort((a, b) => a.itemRate > b.itemRate ? 1 : -1)?.map((uniqueItem, index) => (
                                <><Grid container spacing={1} mt={2}>
                                    <Grid item xs={12} lg={3}>
                                        <Typography variant="subtitle2" gutterBottom>Rate {index + 1}:</Typography>
                                        <Typography variant="body2" gutterBottom>{uniqueItem?.itemRate}</Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <Typography variant="subtitle2" gutterBottom>Unit:</Typography>
                                        <Typography variant="body2" gutterBottom>{uniqueItem?.unitPer}</Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={12} sx={{ mt: 1 }}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{STAKEHOLDER_URN}</TableCell>
                                                        <TableCell>{STAKEHOLDER_NAME}</TableCell>
                                                        {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{REGISTRATION_NO}</TableCell>}
                                                        {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_TYPE}</TableCell>}
                                                        {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_CAPACITY}</TableCell>}
                                                        {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_MAKE}</TableCell>}
                                                        {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{VEHICLE_MODEL}</TableCell>}
                                                        {state?.category == "LLE" && <TableCell>{STATE}</TableCell>}
                                                        {state?.category == "LLE" && <TableCell>{DISTRICT}</TableCell>}
                                                        {state?.category === "Transporter" && <TableCell>{ROUTE}</TableCell>}
                                                        {state?.category === "HIT" && state?.itemType === "Transportation Rate" && <TableCell>Destination</TableCell>}
                                                        {state?.category == "Grower" && <TableCell>{LAND_NAME}</TableCell>}
                                                        {(state?.category == "Grower" && state?.itemType == "Bamboo Rate") && <TableCell>{REVENUE_CIRCLE}</TableCell>}
                                                        <TableCell>Valid From</TableCell>
                                                        <TableCell>Valid To</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer).map((row) => (
                                                        <TableRow>
                                                            <TableCell>{row?.urnNumber}</TableCell>
                                                            <TableCell>{row?.name ? row?.name : row?.stakeholderName}</TableCell>
                                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.registrationNo ? row?.registrationNo : row?.vehicleRegNo}</TableCell>}
                                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleType}</TableCell>}
                                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleCapacity ? row?.vehicleCapacity : row?.vehicleCap}</TableCell>}
                                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleMake}</TableCell>}
                                                            {(state?.category == "HIT" && state?.itemType == "Transportation Rate") && <TableCell>{row?.vehicleModel}</TableCell>}
                                                            {state?.category == "LLE" && <TableCell>{row?.state}</TableCell>}
                                                            {state?.category == "LLE" && <TableCell>{row?.district}</TableCell>}
                                                            {state?.category === "Transporter" && <TableCell>{row?.route ? row?.route : row?.fromName + " to " + row?.toName}</TableCell>}
                                                            {state?.category === "HIT" && state?.itemType === "Transportation Rate" && <TableCell>{row?.toName}</TableCell>}
                                                            {state?.category == "Grower" && <TableCell>{row?.landName}</TableCell>}
                                                            {(state?.category == "Grower" && state?.itemType == "Bamboo Rate") && <TableCell>{row?.revenueCircle}</TableCell>}
                                                            <TableCell>{format(new Date(row?.validFrom), 'dd/MM/yyyy')}</TableCell>
                                                            <TableCell>{format(new Date(row?.validTo), 'dd/MM/yyyy')}</TableCell>
                                                        </TableRow>
                                                    ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                        <Typography variant="subtitle2" gutterBottom>Justification:</Typography>
                                        <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>{uniqueItem?.justification}</Typography>
                                    </Grid>
                                    {state?.selectedRequestNumber && (state?.type !== "sent" && state?.type !== "actionTaken") && <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                        <Typography variant="subtitle2" gutterBottom>Approval/Rejection/Clarification Comment:</Typography>
                                        <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>{uniqueItem?.remarks}</Typography></Grid>}
                                    <Grid item xs={12} sx={{ mt: 1 }}>
                                        {state?.selectedRequestNumber && state?.currentStatus !== "Draft" &&
                                            <><Typography variant="subtitle1">{t('reg.commentHistory')}</Typography>
                                                <TableContainer component={Paper}>
                                                    <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>User</TableCell>
                                                                <TableCell>Comment</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {(state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer)[0]?.workflowRqstDtls?.workflowCommentHistory ? state?.addedRateCardDetailsArr?.filter(filterItem => uniqueItem?.originalRate === filterItem?.itemRate && uniqueItem?.originalUnit === filterItem?.unitPer)[0].workflowRqstDtls?.workflowCommentHistory?.map((commentItem) => ({ ...commentItem, id: uuidv4() })) : []).map((row) => (
                                                                <TableRow>
                                                                    <TableCell>{row?.previousStepUser}</TableCell>
                                                                    <TableCell>{row?.previousStepComments}</TableCell>
                                                                </TableRow>
                                                            ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>}
                                    </Grid>
                                </Grid>
                                </>
                            ))}
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={8} mt={3}>
                                    <Typography variant="subtitle2" gutterBottom>Final summary submission:</Typography>
                                    <Typography variant="body2" gutterBottom sx={{ whiteSpace: 'pre-line' }}>{submissionDetails?.finalSummary}</Typography>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        {(state?.selectedRequestNumber && state?.currentStatus !== "Draft" ? state?.addedRateCardDetailsArr?.[0]?.documents?.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id))?.map((mapItem) => ({ blobFileName: mapItem.documentGuid, fileName: mapItem.documentName })) : documentsArr)?.map((item, index) => {
                                            return (
                                                <div className="Rescview-file-link-common" style={{ display: "flex", flexDirection: "row", marginRight: "2vh" }}>
                                                    <Typography onClick={(e) => viewdownloadDocument((item?.documentGuid || item?.blobFileName), "resourcefiles", (item?.documentName || item?.fileName))}>{item?.fileName || item?.documentName}</Typography>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent >
                    </Card>
                    <Grid item xs={12} md={12} spacing={1} display='flex' justifyContent="flex-end">
                        <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onSubmit(e)}>Submit</Button>
                    </Grid>
                    <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Submit" />
                </Container> :
                <>
                    <Container maxWidth="xxl">
                        {!PROD && <p className='pageNumberingResc'>RES17</p>}
                        
                        {isEditAllowed && isEditMode && (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                <strong>Edit Mode Active:</strong> Form controls are unlocked. Modify the necessary fields and click <strong>"Save Request Edits"</strong> at the bottom to save changes.
                            </Alert>
                        )}

                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                            <Fab onClick={(e) => onGoBack(e)} size="small" aria-label="back" title='Back'>
                                <KeyboardArrowLeftRounded />
                            </Fab>
                            <Typography variant="h5" gutterBottom>
                                {state?.addedRateCardDetailsArr?.[0]?.itemType} {state?.currentStatus === "Draft" ? "Draft" : "Approval"} for {state?.addedRateCardDetailsArr?.[0]?.category}s
                            </Typography>
                        </Stack>
                        {state?.selectedRequestNumber &&
                            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={2}>
                                <Typography variant="h6" gutterBottom>
                                    Assignment-Operation: {state?.currentStatus === "Draft" ? "Create" : state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation}, Request No/Approval Note No: {state?.addedRateCardDetailsArr?.[0]?.requestNumber}, Date: {format(new Date(state?.addedRateCardDetailsArr?.[0]?.createdOn), 'dd/MM/yyyy')}
                                </Typography>
                            </Stack>}
                        {state?.addedRateCardDetailsArr?.[0]?.category === "Grower" && state?.addedRateCardDetailsArr?.[0]?.itemType === "Bamboo Rate" &&
                            <><Grid container spacing={1}>
                                <Grid item xs={12} lg={3} mt={1}>
                                    <Typography variant="subtitle2" gutterBottom>{STATE}</Typography>
                                    <TextField fullWidth disabled value={state?.addedRateCardDetailsArr?.[0]?.state && titleCase(state?.addedRateCardDetailsArr?.[0]?.state)} />
                                </Grid>
                                <Grid item xs={12} lg={3} mt={1}>
                                    <Typography variant="subtitle2" gutterBottom>{DISTRICT}</Typography>
                                    <TextField fullWidth disabled value={state?.addedRateCardDetailsArr?.[0]?.district && titleCase(state?.addedRateCardDetailsArr?.[0]?.district)} />
                                </Grid>
                                {state?.addedRateCardDetailsArr?.[0]?.revenurCircle && <Grid item xs={12} lg={3} mt={1}>
                                    <Typography variant="subtitle2" gutterBottom>{REVENUE_CIRCLE}</Typography>
                                    <TextField fullWidth disabled label={REVENUE_CIRCLE} value={state?.addedRateCardDetailsArr?.[0]?.revenurCircle && titleCase(state?.addedRateCardDetailsArr?.[0]?.revenurCircle)} />
                                </Grid>}
                            </Grid></>
                        }
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={8} mt={2} hidden={state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation === "DELETE"}>
                                <Typography variant="subtitle2" gutterBottom>Background</Typography>
                                <TextField fullWidth
                                    inputProps={{ maxLength: backgroundMaxLength }}
                                    multiline
                                    disabled={effectiveFieldsDisabled}
                                    value={submissionDetails?.background} name="background" onChange={(e) => handleChange(e)}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                    <Badge bg={`${submissionDetails?.background?.length > backgroundMaxLength ? 'danger' : 'primary'}`}>{submissionDetails?.background?.length}/{backgroundMaxLength}</Badge>
                                </div>
                                <div className='resource-common-error-message'>{errorMessage?.backgroundError}</div>
                            </Grid>
                            <Grid item xs={12} lg={5.8} mt={1}>
                                <Typography variant="subtitle2" gutterBottom>Approval Budget(in INR):</Typography>
                                <TextField required fullWidth
                                    onFocus={handleNumberFieldFocus}
                                    error={errorMessage.approvalBudgetError}
                                    helperText={errorMessage.approvalBudgetError}
                                    type='number'
                                    value={approvalBudget}
                                    onChange={(e) => handleApprovalBudget(e)}
                                    disabled={state?.currentStatus !== "Draft" && state?.addedRateCardDetailsArr?.[0]?.approvalBudget ? true : false}
                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                            </Grid>
                        </Grid>
                        {Array.isArray(itemRateUniqueArr) && itemRateUniqueArr.length > 0 &&
                            itemRateUniqueArr
                                .slice()
                                .sort((a, b) => (a.itemRate > b.itemRate ? 1 : -1))
                                .map((uniqueItem, index) => {
                                    const rowsAll = Array.isArray(state?.addedRateCardDetailsArr) ? state.addedRateCardDetailsArr : [];
                                    const safeColumns = Array.isArray(columns) ? columns : [];
                                    const filteredRows = rowsAll.filter((r) => r?.itemRate === uniqueItem?.originalRate && r?.unitPer === uniqueItem?.originalUnit);
                                    const getRowId = (row) => row?.vehicleId ?? row?.transporterTableId ?? row?.landId ?? row?.urnNumber ?? row?.id ?? `${index}-${Math.random()}`;
                                    const commentRows = ((filteredRows?.[0] && filteredRows[0]?.workflowRqstDtls?.workflowCommentHistory) ?? []).map((c) => ({ ...c, id: c.id ?? uuidv4() }));

                                    return (
                                        <React.Fragment key={uniqueItem.id}>
                                            <Grid container spacing={1} mt={2}>
                                                <Grid item xs={12} lg={3}>
                                                    <Typography variant="subtitle2" gutterBottom>Rate {index + 1} (in INR)</Typography>
                                                    <TextField fullWidth
                                                        type="number"
                                                        onFocus={handleNumberFieldFocus}
                                                        disabled={!state?.selectedRequestNumber ? true : effectiveFieldsDisabled}
                                                        value={uniqueItem?.itemRate ?? ""}
                                                        onChange={(e) => handleChange(e, uniqueItem, "rate")}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} lg={3} mt={3.2}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="selectstakeholder-label">{UNIT_PER}</InputLabel>
                                                        <Select
                                                            labelId="unit-label"
                                                            label={UNIT_PER}
                                                            disabled={!state?.selectedRequestNumber ? true : effectiveFieldsDisabled}
                                                            name="unitPer"
                                                            value={uniqueItem?.unitPer || ""}
                                                            onChange={(e) => handleChange(e, uniqueItem, "unitPer")}
                                                            renderValue={(selected) => selected}
                                                        >
                                                            {unitsList?.["unit per"]?.map((unit) => (
                                                                <MenuItem key={unit} value={unit}>
                                                                    {unit}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText sx={{ color: "red" }}>
                                                            {errorMessage?.unitPerError}
                                                        </FormHelperText>
                                                    </FormControl>

                                                </Grid>

                                                <Grid item xs={12} lg={12} sx={{ mt: 1 }}>
                                                    <DataGrid
                                                        autoHeight
                                                        getRowHeight={() => "auto"}
                                                        rows={filteredRows}
                                                        columns={safeColumns}
                                                        pageSize={10}
                                                        getRowId={getRowId}
                                                        components={{ Toolbar: CustomDataGridToolbar }}
                                                        componentsProps={{
                                                            toolbar: {
                                                                rows: filteredRows,
                                                                columns: safeColumns,
                                                                fileName: "List.xlsx",
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} lg={6} sx={{ mt: 1 }} hidden={filteredRows?.[0]?.workflowRqstDtls?.operation === "DELETE"}>
                                                    <Typography variant="subtitle2" gutterBottom>Justification</Typography>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        inputProps={{ maxLength: justificationMaxLength }}
                                                        disabled={effectiveFieldsDisabled}
                                                        name="justification"
                                                        value={uniqueItem?.justification ?? ""}
                                                        onChange={(e) => handleChange(e, uniqueItem)}
                                                    />
                                                    <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "1vh" }}>
                                                        <Badge bg={(uniqueItem?.justification?.length ?? 0) > justificationMaxLength ? "danger" : "primary"}>
                                                            {(uniqueItem?.justification?.length ?? 0)}/{justificationMaxLength}
                                                        </Badge>
                                                    </div>
                                                    <div className="resource-common-error-message">{uniqueItem?.justificationError}</div>
                                                </Grid>

                                                {state?.selectedRequestNumber && state?.type !== "sent" && state?.type !== "actionTaken" && (
                                                    <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                                        <Typography variant="subtitle2" gutterBottom>Approval/Rejection/Clarification Comment</Typography>
                                                        <TextField
                                                            fullWidth
                                                            multiline
                                                            inputProps={{ maxLength: openTextFieldMaxLength }}
                                                            name="remarks"
                                                            value={uniqueItem?.remarks ?? ""}
                                                            onChange={(e) => handleChange(e, uniqueItem)}
                                                        />
                                                        <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "1vh" }}>
                                                            <Badge bg={(uniqueItem?.remarks?.length ?? 0) > characterLimit ? "danger" : "primary"}>
                                                                {(uniqueItem?.remarks?.length ?? 0)}/{characterLimit}
                                                            </Badge>
                                                        </div>
                                                        <div className="resource-common-error-message">{uniqueItem?.remarksError}</div>
                                                    </Grid>
                                                )}

                                                <Grid item xs={12} sx={{ mt: 1 }}>
                                                    {state?.selectedRequestNumber && state?.currentStatus !== "Draft" && (
                                                        <>
                                                            <Typography variant="subtitle1">{t("reg.commentHistory")}</Typography>
                                                            <DataGrid autoHeight getRowHeight={getRowHeight ?? (() => "auto")} rows={commentRows} columns={commentColumns ?? []} pageSize={10} />
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    );
                                })}
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={8} mt={3} hidden={state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation === "DELETE"}>
                                <Typography variant="subtitle2" gutterBottom>Final summary submission</Typography>
                                <TextField fullWidth
                                    inputProps={{ maxLength: openTextFieldMaxLength }}
                                    multiline
                                    name="finalSummary"
                                    disabled={effectiveFieldsDisabled}
                                    value={submissionDetails?.finalSummary} onChange={(e) => handleChange(e)}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                    <Badge bg={`${submissionDetails?.finalSummary?.length > characterLimit ? 'danger' : 'primary'}`}>{submissionDetails?.finalSummary?.length}/{characterLimit}</Badge>
                                </div>
                                <div className='resource-common-error-message'>{errorMessage?.finalSummaryError}</div>
                            </Grid>
                            {state?.addedRateCardDetailsArr?.[0]?.workflowRqstDtls?.operation === "DELETE" &&
                                <Grid item xs={12} lg={8} mt={3}>
                                    <Typography variant="subtitle2" gutterBottom>Final summary</Typography>
                                    <TextField fullWidth disabled value={state?.addedRateCardDetailsArr?.[0]?.deletionComment} onChange={(e) => handleChange(e)} />
                                </Grid>
                            }

                            <Grid item xs={12} lg={6}>
                                {!effectiveFieldsDisabled ? (
                                    <label className="Rescview-file-link-common">
                                        <input style={{ display: "none" }} type="file" accept="image/jpeg, image/jpg, image/png, .pdf" name="photo" onChange={(e) => uploadDocument(e)} />
                                        Choose File
                                    </label>
                                ) : null}

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {(documentsArr)?.map((item) => {
                                        return (
                                            <div className="Rescview-file-link-common" style={{ display: "flex", flexDirection: "row", marginRight: "2vh" }}>
                                                <Typography onClick={(e) => viewdownloadDocument(item?.documentGuid, "resourcefiles", item?.documentName)}>{item?.documentName}</Typography>
                                                {!effectiveFieldsDisabled && <img src={TrashIcon} style={{ cursor: "pointer", marginLeft: "2vh", height: "3vh" }} alt="TrashIcon" onClick={() => state?.currentStatus === "Draft" ? handleDraftDocDelete(item) : handleDelete(item)} />}
                                            </div>
                                        );
                                    })}
                                </div>
                                {!effectiveFieldsDisabled && <Typography variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, .pdf, files.File size limit=5MB)</Typography>}
                                <div className='resource-knowledge-error-message' >{fileuploadError}</div>
                            </Grid>
                        </Grid>
                        {state?.selectedRequestNumber && state?.currentStatus !== "Draft" && (state?.type !== "sent" && state?.type !== "actionTaken") &&
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={8} sx={{ mt: 1 }}>
                                    <Typography variant="subtitle2" gutterBottom>Common Approval/Rejection/Clarification Comment</Typography>
                                    <TextField fullWidth
                                        inputProps={{ maxLength: openTextFieldMaxLength }}
                                        multiline
                                        name="commonComment" value={submissionDetails?.commonComment} onChange={(e) => handleChange(e)}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                        <Badge bg={`${submissionDetails?.commonComment?.length > characterLimit ? 'danger' : 'primary'}`}>{submissionDetails?.commonComment?.length}/{characterLimit}</Badge>
                                    </div>
                                    <p style={{ marginTop: "1vh" }} onClick={(e) => onInsertComment(e)} className="insert-button" >+Insert All</p>
                                </Grid>
                            </Grid>}

                        <Grid item xs={12} md={12} spacing={1} display='flex' justifyContent="flex-end" alignItems="center">
                            
                            {isEditAllowed && (
                                <>
                                    {!isEditMode ? (
                                        <Button
                                            startIcon={<EditIcon />}
                                            sx={{ minWidth: 120, ml: 2, mt: 1 }}
                                            variant="outlined"
                                            color="warning"
                                            onClick={() => setIsEditMode(true)}
                                        >
                                            Enable Edit Mode
                                        </Button>
                                    ) : (
                                        <>
                                            <Button
                                                startIcon={<CloseIcon />}
                                                sx={{ minWidth: 100, ml: 2, mt: 1 }}
                                                variant="outlined"
                                                color="inherit"
                                                onClick={() => setIsEditMode(false)}
                                            >
                                                Cancel Edit
                                            </Button>
                                            <Button
                                                startIcon={<SaveIcon />}
                                                sx={{ minWidth: 140, ml: 2, mt: 1 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={handleConfirmEditWorkflowOpen}
                                            >
                                                Save Request Edits
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}

                            {state?.selectedRequestNumber && state?.currentStatus !== "Draft" ? (
                                <>
                                    <div style={{ display: "none" }}><ComponentToPrint ref={componentRef} /></div>
                                    <ReactToPrint
                                        trigger={() => <Button startIcon={<PrintIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained">Print</Button>}
                                        content={() => componentRef.current}
                                    />
                                </>
                            ) : (
                                <>
                                    <Button startIcon={<SaveIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='save' onClick={onSaveDraft}>Save</Button>
                                    <Button startIcon={<PreviewIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='preview' onClick={PreviewClick}>Preview</Button>
                                </>
                            )}

                            {!isEditMode && (state?.type !== "sent" && state?.type !== "actionTaken") && (
                                <>
                                    {state?.selectedRequestNumber && state?.currentStatus !== "Draft" && state?.addedRateCardDetailsArr?.some(item1 => item1?.workflowRqstDtls?.previousStepAction !== "Seek_Clarification") && (
                                        <>
                                            <Button startIcon={<ReportIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Seek_Clarification")}>Seek clarification for All</Button>
                                            <Button startIcon={<CloseIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Rejected")}>Reject All</Button>
                                            <Button startIcon={<ApproveIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Approved")}>Approve All</Button>
                                        </>
                                    )}
                                    {state?.addedRateCardDetailsArr?.every(item1 => item1?.workflowRqstDtls?.previousStepAction === "Seek_Clarification") && (
                                        <Button sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onAllClick(e, "Rate_Clarification")}>Provide Clarification for All</Button>
                                    )}
                                    {state?.selectedRequestNumber && state?.currentStatus !== "Draft" && (
                                        <Button startIcon={<SubmitIcon />} sx={{ minWidth: 100, ml: 2, mt: 1 }} variant="contained" type='submit' value='add' onClick={(e) => onSubmit(e)}>Submit</Button>
                                    )}
                                </>
                            )}
                        </Grid>

                    </Container>
                    <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Submit" />
                    <ConfirmationPopover onOpen={logConfirmModalOpen2} onConfirm={onConfirmCallBack2} onClose={onCancelBack2} action="Delete" />
                    <ConfirmationPopover onOpen={logConfirmModalOpen3} onConfirm={onConfirmDraftDocDelete} onClose={onCancelDraftDocDelete} action="Delete Draft Doc" />
                    <ConfirmationPopover onOpen={editWorkflowConfirmModalOpen} onConfirm={onConfirmEditWorkflow} onClose={handleConfirmEditWorkflowClose} action="Edit Request" />
                </>}
        </>
    );
}

export default PreviewRateCard;
